import React, { useEffect, useRef } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import s from "./RussiaHivMigrantsTreatment.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import {
  getRussiaHiVMigrantsDetails,
  getRussiaHiVMigrantsTreatmentList,
} from "../../redux/InformationSlice";
import { Link, useParams } from "react-router-dom";
import Navigation from "../../Components/Navigation/Navigation";
import ContactButtons from "../../Components/ContactButtons/ContactButtons";
import ScrollToTop from "../../Components/ScrollToTop/ScrollToTop";
import InCountry from "../../Components/InCountry/InCountry";
import useWindowDimensions from "../../Components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../Components/MobileHeader/MobileHeader";
import { Seo } from "../../Seo";

const RussiaHivMigrantsTreatment = () => {
  const data = useSelector(
    (state: RootState) => state.info.russiaHiVMigrantsDetails,
  );
  const treatmentList = useSelector(
    (state: RootState) => state.info.russiaHiVMigrantsTreatmentList,
  );
  const lang = useSelector((state: RootState) => state.info.lang);
  const langs: Record<string, string> = {
    ru: "button_ru",
    kg: "button_ky",
    tj: "button_tg",
    uz: "button_uz",
  };

  const params = useParams();
  const dispatch: AppDispatch = useDispatch();
  const { width } = useWindowDimensions();

  useEffect(() => {
    dispatch(getRussiaHiVMigrantsDetails(Number(params.id)));
    dispatch(getRussiaHiVMigrantsTreatmentList());
  }, [dispatch, params]);

  const getPath = (button: string, id: number) => {
    switch (button) {
      case "Получать лечение за свой счёт":
        return `/russia/hiv/migrants/treatment/self-founded/${id}`;
      case "Дистанционный учет":
        return `/russia/hiv/migrants/treatment/remote/${id}`;
      default:
        return `/russia/hiv`;
    }
  };

  const footerRef = useRef<HTMLDivElement | null>(null);
  const scrollToFooter = () => {
    footerRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div>
      <Seo
        title="Узнал о своём ВИЧ-статусе в России?"
        description="Что делать мигранту при выявлении ВИЧ в РФ."
        url="https://www.vputi.org/russia/hiv/migrants/analysis/3"
      />
      <div className={s.content}>
        {width > 1100 ? (
          <Header onContactsClick={scrollToFooter} />
        ) : (
          <MobileHeader onContactsClick={scrollToFooter} />
        )}
        <InCountry />
        <Navigation
          navigation={{
            name: "Главная / Законодательство России / ВИЧ / Информация для мигрантов с ВИЧ / Как получать лечение",
            path: "/russia/hiv/migrants/3",
          }}
        />
        <ContactButtons />
        <div className={s.text}>
          <div className={s.title}>{data?.title_1}</div>
          <div
            className={s.body}
            dangerouslySetInnerHTML={{ __html: data?.body_1 ?? "" }}
          ></div>
          {
            <div className={s.yellow_wrapper}>
              <div
                className={s.body2}
                dangerouslySetInnerHTML={{ __html: data?.body_2 ?? "" }}
              ></div>
            </div>
          }
          <div className={s.buttons}>
            {Array.isArray(treatmentList) &&
              [...treatmentList]
                .reverse()

                .map((it) => {
                  const field = langs[lang] || "button_ru";
                  const buttonText = (it as any)[field] || it.button;

                  return (
                    <Link
                      to={getPath(it.button, it.id)}
                      key={it.id}
                      className={s.button}
                      onClick={() => getRussiaHiVMigrantsDetails(it.id)}
                    >
                      {buttonText}
                    </Link>
                  );
                })}
          </div>
        </div>
      </div>
      <div ref={footerRef}>
        <Footer />
      </div>
      <ScrollToTop />
    </div>
  );
};

export default RussiaHivMigrantsTreatment;
